import { useRecoilState } from "recoil";
import { userDetailsAtom } from "../atoms/userAtoms";

export const useUserDetails = () => {
  const [userDetails, setUserDetails] = useRecoilState(userDetailsAtom);
  return [userDetails, setUserDetails] as const;
};